import { createRequest } from '@widget-kit/container';

function initPositionFixedPlugin(container, config) {
    if (config === void 0) { config = {}; }
    var iframe = container.iframe, handle = container.handle;
    function setPosition(position) {
        position.top && (iframe.style.top = position.top);
        position.left && (iframe.style.left = position.left);
        position.right && (iframe.style.right = position.right);
        position.bottom && (iframe.style.bottom = position.bottom);
    }
    iframe.style.position = 'fixed';
    if (config.initialPosition) {
        setPosition(config.initialPosition);
    }
    handle("plugins.positionFixed.setPosition" /* setPosition */, function (_, position) {
        setPosition(position);
    });
}
function setPosition(position) {
    return createRequest("plugins.positionFixed.setPosition" /* setPosition */, position);
}

export { initPositionFixedPlugin, setPosition };
//# sourceMappingURL=index.esm.js.map
